// extracted by mini-css-extract-plugin
export var active = "_dl-7";
export var container = "_dl-0";
export var evenWidth = "_dl-4";
export var large = "_dl-5";
export var outlet = "_dl-8";
export var slide = "_dl-2";
export var small = "_dl-6";
export var tab = "_dl-3";
export var tabs = "_dl-1";